module.exports = __webpack_public_path__ + "img/help/create-link.2486371f36499a79d7e59dbbece79e49.png";